import { JobResourceCategory } from "@crimsontide/core/client/interfaces";
import DotNetObject = DotNet.DotNetObject;

export const DocStoreService = (() => {
  let dotNetObj: DotNetObject;
  let cachedDocStoreCategories: JobResourceCategory[];
  let tempDocStoreCategories: JobResourceCategory[] = [];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getDocStoreCategories = async (useCache: boolean = true): Promise<JobResourceCategory[]> => {
    if (useCache && cachedDocStoreCategories != null)
      return cachedDocStoreCategories;

    if (dotNetObj) {
      cachedDocStoreCategories = await dotNetObj.invokeMethodAsync<JobResourceCategory[]>('GetDocStoreCategoriesAsync');
      return cachedDocStoreCategories;
    } else {
      throw 'DocStore DotNet Object Reference has not yet been implemented';
    }
  };
  const getTempDocStoreCategories = (): JobResourceCategory[] => {
    return tempDocStoreCategories;
  };
  const addNewTempDocStoreCategory = (newCategory: JobResourceCategory): void => {
    tempDocStoreCategories.push(newCategory)
  };

  const clearTempDocStoreCategory = (): void => {
    tempDocStoreCategories = [];
  };

  const uploadResource = async (resourceId: string, file: Blob): Promise<string> => {
    if (dotNetObj) {
      const mimeType: string = file.type;

      const fileAsArrayBuffer: ArrayBuffer = await file.arrayBuffer();
      const fileContents: Uint8Array = new Uint8Array(fileAsArrayBuffer);

      return await dotNetObj.invokeMethodAsync<string>('UploadResourceAsync', resourceId, fileContents, mimeType);
    } else {
      throw 'DocStore DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getDocStoreCategories,
    uploadResource,
    getTempDocStoreCategories,
    addNewTempDocStoreCategory,
    clearTempDocStoreCategory
  };
})();
